"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DocumentContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var DocumentContext = /*#__PURE__*/_react.default.createContext();

exports.DocumentContext = DocumentContext;

var DocumentProvider = function DocumentProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentDocument = _useState2[0],
      setCurrentDocument = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      rawDocument = _useState4[0],
      setRawDocument = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      recordData = _useState6[0],
      setRecordData = _useState6[1];

  if (currentDocument instanceof Error) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Error while parsing the Document"), /*#__PURE__*/_react.default.createElement("pre", null, document.stack || document.message));
  }

  return /*#__PURE__*/_react.default.createElement(DocumentContext.Provider, {
    value: {
      currentDocument: currentDocument,
      setCurrentDocument: setCurrentDocument,
      rawDocument: rawDocument,
      setRawDocument: setRawDocument,
      recordData: recordData,
      setRecordData: setRecordData
    }
  }, children);
};

var _default = DocumentProvider;
exports.default = _default;